import { request } from "../../../services/api.ts"
import type {
  StatusRecordKind,
  StatusSuggestionAcceptBody,
  StatusTransition
} from "../types/status-automation.types.ts"

const recordPath = (kind: StatusRecordKind, recordId: string) =>
  kind === "lead"
    ? `/crm/leads/${recordId}`
    : `/project-management/projects/${recordId}`

export const STATUS_AUTOMATION_PATHS = {
  transitions: (kind: StatusRecordKind, recordId: string) =>
    `${recordPath(kind, recordId)}/status-transitions/`,
  undo: (kind: StatusRecordKind, recordId: string, transitionId: string) =>
    `${recordPath(kind, recordId)}/status-transitions/${transitionId}/undo/`,
  accept: (kind: StatusRecordKind, recordId: string, suggestionId: string) =>
    `${recordPath(kind, recordId)}/status-suggestions/${suggestionId}/accept/`,
  dismiss: (kind: StatusRecordKind, recordId: string, suggestionId: string) =>
    `${recordPath(kind, recordId)}/status-suggestions/${suggestionId}/dismiss/`
}

// GET is bare; the three POSTs answer inside the write envelope on success and
// bare on a refusal, so callers read both through `unwrapEnvelope` /
// `readStatusRefusal`.
export const getStatusTransitions = (
  kind: StatusRecordKind,
  recordId: string
) =>
  request.api.get<StatusTransition[]>(
    STATUS_AUTOMATION_PATHS.transitions(kind, recordId)
  )

export const undoStatusTransition = (
  kind: StatusRecordKind,
  recordId: string,
  transitionId: string
) =>
  request.api.post<unknown>(
    STATUS_AUTOMATION_PATHS.undo(kind, recordId, transitionId)
  )

export const acceptStatusSuggestion = (
  kind: StatusRecordKind,
  recordId: string,
  suggestionId: string,
  body: StatusSuggestionAcceptBody = {}
) =>
  request.api.post<unknown>(
    STATUS_AUTOMATION_PATHS.accept(kind, recordId, suggestionId),
    body
  )

export const dismissStatusSuggestion = (
  kind: StatusRecordKind,
  recordId: string,
  suggestionId: string
) =>
  request.api.post<unknown>(
    STATUS_AUTOMATION_PATHS.dismiss(kind, recordId, suggestionId)
  )
